import React, { useEffect } from 'react';
import Table from '@awp/components/table';
import { useSelector, useDispatch } from 'react-redux';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { Permissions, FORM_MODE } from '@awp/constants';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import Authorize from '@awp/components/Authorize';
import { ActionMenuView, ActionMenuEdit } from '@awp/components/Common/AwpActionMenus';
import { ToastContainer, toast } from 'react-toastify';
import AwpToastContent from '@components/Common/AwpToastContent';
import Dropdown from '@awp/components/Common/DropDown/Dropdown';
import {
  selectAllModelstatuses,
  selectModelstatusId,
  setModelstatus,
  getModelstatusLoading,
  selectAllTypes,
  selectTypeId,
  getTypeLoading,
  setType,
  selectAllManufacturers,
  selectManufacturerId,
  getManufacturerLoading,
  setManufacturer,
} from '@stores/sensorModelSlice';
import SensorModelService from '@components/SensorModelAdmin/SensorModelService';
const SensorModelTable = ({
  isMedium,
  isLarge,
  data,
  loading,
  setMode,
  mode,
  setSensorModel,
  search,
  setSearch,
  filteredData,
  setFilteredData,
  defaultPageSize,
  setDefaultPageSize,
}) => {
  const dispatch = useDispatch();
  const allModelstatuses = useSelector(selectAllModelstatuses);
  const currentModelstatusId = useSelector(selectModelstatusId);
  const currentStatusLoading = useSelector(getModelstatusLoading);
  const allTypes = useSelector(selectAllTypes);
  const currentTypeId = useSelector(selectTypeId);
  const currentTypeLoading = useSelector(getTypeLoading);
  const allManufacturers = useSelector(selectAllManufacturers);
  const currentManufacturerId = useSelector(selectManufacturerId);
  const currentManufacturerLoading = useSelector(getManufacturerLoading);

  const crudService = new SensorModelService(mode);

  const setCurrentModelStatus = (id) => async (dispatch) => {
    const status = allModelstatuses.find((x) => x.Id === id);
    dispatch(setModelstatus(status));
  };

  const setCurrentType = (id) => async (dispatch) => {
    const type = allTypes.find((x) => x.Id === id);
    dispatch(setType(type));
  };

  const setCurrentManufacturer = (id) => async (dispatch) => {
    const man = allManufacturers.find((x) => x.Id === id);
    dispatch(setManufacturer(man));
  };

  const actionMenu = (row) => {
    return (
      <>
        <div>
          <Authorize requires={[Permissions.WriteSensorModel]}>
            <ActionMenuEdit
              onClick={() => {
                setMode(FORM_MODE.EDIT);
                setSensorModel(row.row.original);
              }}
            />
          </Authorize>
          <ActionMenuView
            onClick={() => {
              setMode(FORM_MODE.VIEW);
              setSensorModel(row.row.original);
            }}
          />
        </div>
      </>
    );
  };
  const hasSearch = (src) => {
    return src ? src.toLowerCase().includes(search.toLowerCase()) : false;
  };
  useEffect(() => {
    if (!data || data.length === 0) return;
    let filtered = [...data];
    if (allModelstatuses && currentManufacturerId > 0) {
      filtered = filtered.filter((wx) => wx.ManufacturerId === currentManufacturerId);
    }
    if (allTypes && currentTypeId > 0) {
      filtered = filtered.filter((wx) => wx.TypeId === currentTypeId);
    }
    // const status = allModelstatuses.find((wss) => wss.StatusTypeId == currentModelstatusId);
    // if (status) {
    if (allModelstatuses && currentModelstatusId > 0) {
      filtered = filtered.filter((wx) => wx.StatusTypeId === currentModelstatusId);
    }
    if (!isValueEmpty(search)) {
      filtered = filtered.filter(
        (sm) =>
          hasSearch(sm.ManufacturerName) || hasSearch(sm.ModelNumber) || hasSearch(sm.Status) || hasSearch(sm.Type),
      );
    }

    setFilteredData(filtered);
  }, [data, search, currentManufacturerId, currentTypeId, currentModelstatusId]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Model Number',
        accessor: 'ModelNumber',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Manufacturer',
        accessor: 'ManufacturerName',
        show: isLarge,
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Status',
        accessor: 'Status',
        show: isMedium,
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Type',
        accessor: 'Type',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Actions',
        accessor: 'Id',
        disableSortBy: true,
        Cell: actionMenu,
      },
    ],
    [isLarge, isMedium],
  );

  return (
    <>
      <div className="d-flex">{crudService.crud.getHeader()}</div>
      <div className="container mb-3">
        <div className="row">
          <div className="col-sm-3">
            <Form.Label>
              <b>{'Search'}</b>
            </Form.Label>
            <input
              className="form-control float-left"
              placeholder="Search..."
              id="user_text_search"
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            ></input>
          </div>
          <div className="col-sm-3">
            <Dropdown
              ChangeHandler={setCurrentManufacturer}
              AllOptions={selectAllManufacturers}
              CurrentValue={selectManufacturerId}
              LoadingStatus={currentManufacturerLoading}
              Title={'Manufacturer'}
            />
          </div>
          <div className="col-sm-3">
            <Dropdown
              ChangeHandler={setCurrentModelStatus}
              AllOptions={selectAllModelstatuses}
              CurrentValue={selectModelstatusId}
              LoadingStatus={currentStatusLoading}
              Title={'Status'}
            />
          </div>
          <div className="col-sm-3 pr-0">
            <Dropdown
              ChangeHandler={setCurrentType}
              AllOptions={selectAllTypes}
              CurrentValue={selectTypeId}
              LoadingStatus={currentTypeLoading}
              Title={'Type'}
            />
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        data={filteredData}
        fetchData={() => {}}
        loading={loading}
        search=""
        defaultSortBy="Name"
        defaultPageSize={defaultPageSize}
        setDefaultPageSize={setDefaultPageSize}
      />
      <div className="container mb-3" style={{ paddingTop: '1.25rem' }}>
        <div className="row">
          <div className="col-md-12 col-lg-12 col-sm-12 pr-0 pl-0">
            <Authorize requires={[Permissions.WriteSensorModel]}>
              <Button
                className="mr-2 mr-mini-0 float-left"
                variant="primary"
                onClick={() => {
                  setMode(FORM_MODE.CREATE);
                }}
                disabled={loading}
              >
                Create
              </Button>
            </Authorize>
          </div>
        </div>
      </div>
    </>
  );
};

export default SensorModelTable;
